import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import useRfiSendCategoriesReminder from 'router/subrouters/DataRoom/hooks/useRfiSendCategoriesReminder';
import {
  DataRoomRFICategory,
  RFI_SEND_REMINDER_TRIGGER,
} from 'router/subrouters/DataRoom/models/DataRoomRfi';
import { getArrayLength, getHasElementsInArray } from 'utils';

import './RfiCategoriesActionMenu.styles.scss';

type RfiCategoriesActionMenuProps = {
  className?: string;
  selected: DataRoomRFICategory[];
  onCategoryUpdate: (category: DataRoomRFICategory) => void;
  onReassignClick: () => void;
  onClose: () => void;
};

const RfiCategoriesActionMenu: React.FC<RfiCategoriesActionMenuProps> = (
  props,
) => {
  const { className, selected, onCategoryUpdate, onReassignClick, onClose } =
    props;

  const { t } = useTranslation();

  const { loading, sendCategoriesReminder } = useRfiSendCategoriesReminder(
    selected,
    RFI_SEND_REMINDER_TRIGGER.SELECTION_BAR,
    onCategoryUpdate,
    onClose,
  );

  const classes = classNames('rfi-categories-action-menu', className);

  if (!getHasElementsInArray(selected)) return null;

  return (
    <div className={classes}>
      <p>{t('selectedCount', { count: getArrayLength(selected) })}</p>

      <div className="rfi-categories-action-menu__actions">
        <Button variant="link" onClick={onClose}>
          {t('clear')}
        </Button>
        <Button
          variant="outline"
          disabled={loading}
          onClick={sendCategoriesReminder}
        >
          {t('remind')}
        </Button>
        <Button onClick={onReassignClick}>{t('reassign')}</Button>
      </div>
    </div>
  );
};

export default RfiCategoriesActionMenu;
